import { TimelineMax, TweenMax, Power2, Power3, Power4, Power1 } from "gsap"
import { cos, sin } from "mathjs"
import DebugController from '@/glxp/debug/debugController'

const SCENE_STATES = ["intro", "stage1", "stage2", "stage3"]
let haloValues = [0.2, 0.4, 0.7, 0.7]


class AnimationManager {
    constructor(scene){
        this.scene = scene

        this.state = "intro"
        this.stateId = 0
        this.statesPrerenderFunctions = {
            intro: ()=>{this.introPrerender()},
            stage1: () => { this.stage1Prerender()},
            stage2: () => { this.stage2Prerender()},
            stage3: () => { this.stage3Prerender()},
        }

        this.rotation = 0
        this.sayHi.bind(this)
        this.plateformVisible = false
        
    }


    startIntro(){
        let tl = new TimelineMax()

        tl.to(this.scene, 4, {
            timeScale: 1,
            ease: Power3.easeInOut
        }, "0")

    }

    shakeCam() {
        this.scene.shake = true
        TweenMax.delayedCall(.5, () => {
            this.scene.shake = false
        })
    }

    blinkHand(id) {
        this.blinkVal = 0
        TweenMax.fromTo(this, {
            blinkVal: 0,
        }, {
            blinkVal: 1,
            duration: .2,
            // ease: "power.inOut",
            repeat: 3,
            // delay: 3,
            yoyo: true,
            onComplete: ()=>{
                this.scene.handsRigs[id].mesh.preventPost = true
                this.scene.halo.power = haloValues[this.stateId]
            },
            onUpdate: () => {
                this.scene.halo.power = this.blinkVal
            },
            onStart:()=>{
                this.scene.handsRigs[id].mesh.preventPost = false
            },
        })
    }

    showHandRig(id){
        let n = this.scene.handsRigs[id].rootNode
        this.scene.handsRigs[id].mesh.active = true

        let tmp = { x: 0, y: 10, z: 0, rx: 0, ry: 0, rz: 0, sx: 0, sy: 0, sz: 0 }
        let tl = new TimelineMax()

        tl.to(tmp, {
            duration: 2.5,
            sx: 10,
            sy: 10,
            sz: 10,
            ease: "power3.out",
            onUpdate: ()=>{
                n.scale[0] = tmp.sx
                n.scale[1] = tmp.sy
                n.scale[2] = tmp.sz
                n.needUpdate = true
            }
        }, "0")

        tl.to(tmp, {
            duration: 3,
            ry: id == 0 ? Math.PI * 2 : Math.PI * 3,
            ease: "power3.inOut",
            onUpdate: ()=>{
                n.rotation[1] = tmp.ry
                n.needUpdate = true
            }
        }, "0")

    }

    hideHandRig(id){
        let n = this.scene.handsRigs[id].rootNode
        this.scene.handsRigs[id].mesh.active = true

        let tmp = { x: 0, y: 10, z: 0, rx: 0, ry: id == 0 ? 0 : Math.PI, rz: 0, sx: 10, sy: 10, sz: 10 }
        let tl = new TimelineMax()

        tl.to(tmp, {
            duration: 1,
            sx: 0,
            sy: 0,
            sz: 0,
            ease: "power3.inOut",
            onUpdate: () => {
                n.scale[0] = tmp.sx
                n.scale[1] = tmp.sy
                n.scale[2] = tmp.sz
                n.needUpdate = true
            }
        }, "1")

        tl.to(tmp, {
            duration: 2,
            ry: id == 0 ? Math.PI * 2 : Math.PI * 3,
            ease: "power3.inOut",
            onUpdate: () => {
                n.rotation[1] = tmp.ry
                n.needUpdate = true
            }
        }, "0")
    }

    start(){
        let tl = new TimelineMax()

        let tmpCamPos = {
            z: this.scene.camera.node.initialPosition[2],
        }
        tl.to(tmpCamPos, {
            duration: 3.5,
            ease: "power2.inOut",
            z: this.scene.cameraTargets[0][2],
            onUpdate: ()=>{
                this.scene.camera.node.initialPosition[2] = tmpCamPos.z
            }
        }, "0")
        tl.add(()=>{
            this.goToStage(0)
        }, .75)

        for (let i = 0; i < this.scene.meshes.length; i++) {
            if (this.scene.meshes[i].parent == "Bosquet") {
                let pos = { x: this.scene.meshes[i].node.position[0], y: this.scene.meshes[i].node.position[1], z: this.scene.meshes[i].node.position[2] }
                let rot = { x: this.scene.meshes[i].node.rotation[0], y: this.scene.meshes[i].node.rotation[1], z: this.scene.meshes[i].node.rotation[2] }
                let delay = ((-this.scene.meshes[i].node.position[2] + 50) / 500) + 1.5
                if (this.scene.meshes[i].node.position[0] > 0) {   
                    tl.to(pos, 1.5, { x: pos.x + 250, y: pos.y - 100,  ease: Power2.easeInOut,
                        onUpdate: ()=>{
                        this.scene.meshes[i].node.position[0] = pos.x
                        this.scene.meshes[i].node.position[1] = pos.y
                        this.scene.meshes[i].node.needUpdate = true
                        }
                    }, (delay)+"")
                    tl.to(rot, 1.5, {
                        z: rot.z - .1, x: -1.2, ease: Power2.easeInOut,
                        onUpdate: ()=>{
                        this.scene.meshes[i].node.rotation[0] = rot.x
                        this.scene.meshes[i].node.rotation[2] = rot.z
                        this.scene.meshes[i].node.needUpdate = true
                        }
                    }, (delay)+"")
                } else {
                    tl.to(pos, 1.5, { x: pos.x - 250, y: pos.y - 100, ease: Power2.easeInOut,
                        onUpdate: ()=>{
                        this.scene.meshes[i].node.position[0] = pos.x
                        this.scene.meshes[i].node.position[1] = pos.y
                        this.scene.meshes[i].node.needUpdate = true
                        }
                    }, (delay)+"")
                    tl.to(rot, 1.5, {
                        z: rot.z + .1, x: -1.2, ease: Power2.easeInOut,
                        onUpdate: ()=>{
                        this.scene.meshes[i].node.rotation[0] = rot.x
                        this.scene.meshes[i].node.rotation[2] = rot.z
                        this.scene.meshes[i].node.needUpdate = true
                        }
                    }, (delay)+"")
                }
                tl.add(()=>{ this.scene.meshes[i].active = false }, "5")
            }
        }
        tl.to(this.scene, 4, {
            cameraFreedom: 1,
            ease: Power3.easeInOut
        }, "0")

        let sun = this.scene.getMesh("Sun")
        sun.rot = 0
    
        tl.fromTo(sun, 3.5, { rot: Math.PI/3 }, { rot:  0, ease: Power3.easeOut, delay: 1.2,
            onUpdate: ()=>{
                sun.node.rotation[2] = sun.rot
                sun.node.position[1] = -50
                sun.node.needUpdate = true
            }
        }, "0")


        // Butterfly Animation
        let butterflyMesh1 = this.scene.getMesh("Butterfly-mesh-1")
        let butterflySpline1 = this.scene.getSpline("Butterfly-spline-1")
        let buttterFlyTmp = { p: 0 }
        tl.to(buttterFlyTmp, {
            duration: 8,
            delay: 1.5,
            p: 1,
            onUpdate: ()=>{
                butterflyMesh1.node.position = butterflySpline1.getPointLinearMotion(buttterFlyTmp.p)
                butterflyMesh1.node.needUpdate = true
                butterflyMesh1.node.getMatrix()
                butterflyMesh1.node.lookAt(butterflySpline1.getPointLinearMotion(buttterFlyTmp.p + 0.01)) 
            },
            onComplete: ()=>{
                butterflyMesh1.active = false
            }
        }, "0.5")

        let butterflyMesh2 = this.scene.getMesh("Butterfly-mesh-2")
        let butterflySpline2 = this.scene.getSpline("Butterfly-spline-2")
        let buttterFlyTmp2 = { p: 0 }
        tl.to(buttterFlyTmp2, {
            duration: 9,
            p: 1,
            delay: 1.5,
            onUpdate: ()=>{
                butterflyMesh2.node.position = butterflySpline2.getPointLinearMotion(buttterFlyTmp2.p)
                butterflyMesh2.node.needUpdate = true
                butterflyMesh2.node.getMatrix()
                butterflyMesh2.node.lookAt(butterflySpline2.getPointLinearMotion(buttterFlyTmp2.p + 0.01)) 
            },
            onComplete: ()=>{
                butterflyMesh2.active = false
            }
        }, "0.2")

        // setTimeout(() => {
        //     this.showPlateform()
        // }, 3000)

        this.startTL = tl
    }

    unStart() {
        this.startTL.reverse()
    }

    goToStage(id){

        if (this.scene.activeScenes.indexOf("Scene_" + Math.min(id + 1, 3)) < 0) {
            this.scene.activeScenes.push("Scene_" + Math.min(id + 1, 3))

            if (DebugController.queryDebug()) {
                this.scene.activeScenes = ["global", "Scene_1", "Scene_2", "Scene_3"]
            }

        }

        // A REMETRE
        // TweenMax.delayedCall(3.2, () => {
        //     for (let i = 0; i < this.scene.activeScenes.length; i++) {
        //         if (this.scene.activeScenes[i] !== "Scene_" + Math.min(id + 1, 3) && this.scene.activeScenes[i] !== "global"){
        //             this.scene.activeScenes.splice(i, 1)
        //         }
        //     }
        // })

        for (let i = 0; i < this.scene.plateformMeshes.length; i++) {
            const mesh = this.scene.plateformMeshes[i];

            TweenMax.to(mesh, {
                duration: 4,
                colorSet: id > 1 ? 1 : 0,
                ease: "power3.inOut"
            })
        }


        let plateformYValues = [0, 640, 1440, 2240]

        let tmpCamPos = { 
            y: this.scene.camera.node.initialPosition[1],
            lookatY: this.scene.lookatNode.position[1], 
            plateformOffset: this.scene.plateformRootNode.position[1],
            handsOffset: this.scene.handsRootNode.position[1],
         }
        
        TweenMax.to(tmpCamPos, 2.5, {
            y: this.scene.cameraTargets[id][1],
            lookatY: this.scene.cameraTargetsLookat[id][1],
            ease: Power3.easeInOut,
            onUpdate: ()=>{ 
                this.scene.camera.node.initialPosition[1] = tmpCamPos.y
                this.scene.lookatNode.position[1] = tmpCamPos.lookatY
                this.scene.plateformRootNode.position[1] = tmpCamPos.plateformOffset
                this.scene.plateformRootNode.needUpdate = true
            },
            delay: .1
        })

        TweenMax.to(tmpCamPos, 1.5, {
            plateformOffset: plateformYValues[id],
            ease: Power3.easeInOut,
            onUpdate: ()=>{ 
                this.scene.plateformRootNode.position[1] = tmpCamPos.plateformOffset
                this.scene.plateformRootNode.needUpdate = true
            }
        })

        TweenMax.to(tmpCamPos, 1.2, {
            handsOffset: plateformYValues[id],
            ease: Power4.easeInOut,
            onUpdate: ()=>{ 
                this.scene.handsRootNode.position[1] = tmpCamPos.handsOffset
                this.scene.handsRootNode.needUpdate = true
            }
        })

        TweenMax.to(this.scene.halo, 1, {
            power: haloValues[id],
            ease: Power4.easeInOut,
        })
        
        this.state = SCENE_STATES[id]
        this.stateId = id

    }

    rippleWater(){
        TweenMax.fromTo(this.scene.water, 9, { progress: 0}, { progress: 1, ease: Power2.easeOut })
    }
    
    sayHi(id){
        let tl = new TimelineMax()
        tl.to(this, 0.5, {rotation: -0.1, ease: Power2.easeIn, onUpdate: () => {this.updateRotation(id)}})
        tl.to(this, 0.5, {rotation: 0.1, onUpdate: () => {this.updateRotation(id)}})
        tl.to(this, 0.5, {rotation: -0.1, onUpdate: () => {this.updateRotation(id)}})
        tl.to(this, 0.5, {rotation: 0, ease: Power2.easeOut, onUpdate: () => {this.updateRotation(id)}})
        tl.play()
    }

    shootStar () {
        this.scene.shootingStar.node.position[0] = Math.random() * 2000 - 1000
        this.scene.shootingStar.node.position[1] = 1000 + Math.random() * 1000
        let angle = - Math.random() * (Math.PI)
        if(angle < -Math.PI/2 && angle > -3 * Math.PI/4){
            angle = -Math.PI/4
        } else if(angle > -Math.PI/2 && angle <  Math.PI/4) {
            angle = -3*Math.PI/4
        }
        this.scene.shootingStar.angle = angle
        this.scene.shootingStar.node.needUpdate = true
        this.progressShoot = 0
        TweenMax.fromTo(this, 2, {progressShoot: 0 }, { progressShoot: 1, onUpdate: () => {
            this.scene.shootingStar.progress = this.progressShoot
        },
        onComplete: () =>{
            TweenMax.delayedCall(5, () => {this.shootStar()})
        }})
    }

    updateRotation(id) {
        this.scene.handsRigs[id].rootNode.rotation[2] = this.rotation
        this.scene.handsRigs[id].rootNode.needUpdate = true

    }

    tutoSuccess() {
        this.blinkHand(0) 
        this.rippleWater()
    }

    showPlateform(){

        this.plateformVisible = true

        TweenMax.to(this.scene.plateformShadow, 3, { opacity: .25, delay: 1 })

        TweenMax.delayedCall(1, () => {
            this.rippleWater()
        })

        let tl = new TimelineMax()
        for (let i = 0; i < this.scene.plateformMeshes.length; i++) {
            const mesh = this.scene.plateformMeshes[i];
            mesh.active = true
            tl.to(mesh, 2.5, {
                progress: 1,
                ease: Power3.easeInOut,
                delay: i * .01,
                onUpdate: ()=>{
                    mesh.node.scale[1] = mesh.progress
                    mesh.node.needUpdate = true
                }
            }, "0")
            tl.to(mesh, 1.5, {
                opacity: 1,
                ease: Power3.easeInOut,
                delay: i * .01,
            }, "0.5")

            let tmpPos = { y: -50 }
            tl.to(tmpPos, 4, {
                y: 0,
                ease: Power3.easeOut,
                delay: i * .1,
                onUpdate: ()=>{
                    mesh.node.position[1] = tmpPos.y
                    mesh.node.needUpdate = true
                }
            }, "0")
        }

    }

    hidePlateform(){
        this.plateformVisible = false
        TweenMax.to(this.scene.plateformShadow, 2, { opacity: 0 })
        let tl = new TimelineMax()
        for (let i = 0; i < this.scene.plateformMeshes.length; i++) {
            const mesh = this.scene.plateformMeshes[i];
            mesh.active = true
            tl.to(mesh, 2.5, {
                progress: 0,
                ease: Power3.easeInOut,
                delay: i * .01,
                onUpdate: () => {
                    mesh.node.scale[1] = mesh.progress
                    mesh.node.needUpdate = true
                }
            }, "0")
            tl.to(mesh, 1.5, {
                opacity: 0,
                ease: Power3.easeInOut,
                delay: i * .01,
            }, "0.5")

            let tmpPos = { y: 0 }
            tl.to(tmpPos, 4, {
                y: -50,
                ease: Power3.easeOut,
                delay: i * .1,
                onUpdate: () => {
                    mesh.node.position[1] = tmpPos.y
                    mesh.node.needUpdate = true
                }
            }, "0")
        }
    }

    moveHandToFightPosition(id){
        let handNode = this.scene.handsRigs[id].rootNode
        let tmp = { x: handNode.position[0], y: handNode.position[1], z: handNode.position[2], rx: 0, ry: 0, rz: 0}
        TweenMax.to(tmp, {
            duration: 1,
            ease: "power2.inOut",
            x: id == 0 ? 150 : -150,
            y: 30,
            z: id == 0 ? -400 : -600,
            onUpdate: ()=>{
                handNode.position[0] = tmp.x
                handNode.position[1] = tmp.y
                handNode.position[2] = tmp.z
                handNode.needUpdate = true
            }
        })
    }

    playShiFuMiAnimation(){
        this.scene.handsRigs[0].animator.playShifumiAnimation();
        this.scene.handsRigs[1].animator.playShifumiAnimation();
    }

    preRender(){

        this.statesPrerenderFunctions[this.state]()

        let plane = this.scene.getMesh("Plane")
        plane.node.position[0] = -3000 + ((plane.time * .01 + .2) % 1) * (1500 * 2)
        plane.node.needUpdate = true
        
    }
    
    introPrerender(){
        // Nenuphar Animation
        for (let i = 0; i < this.scene.nenuphars.length; i++) {
            this.scene.nenuphars[i].node.rotation[1] += this.scene.nenuphars[i].rotSeed * .001
            this.scene.nenuphars[i].node.position[0] = this.scene.nenuphars[i].initialPosition[0] + Math.cos(this.scene.time * .075 * this.scene.nenuphars[i].rotSeed + this.scene.nenuphars[i].rotSeed * 100) * 10 
            this.scene.nenuphars[i].node.position[2] = this.scene.nenuphars[i].initialPosition[2] + Math.sin(this.scene.time * .075 * this.scene.nenuphars[i].rotSeed + this.scene.nenuphars[i].rotSeed * 100) * 10
            this.scene.nenuphars[i].node.needUpdate = true
        }

        let butterflyMesh = this.scene.getMesh("Butterfly-mesh-3")
        if (this.scene.time % 30 > 15 && this.scene.time % 30 < 25){
            let t = Math.min(((this.scene.time % 30) - 15) / 10, 1.)
            let butterflySpline = this.scene.getSpline("Butterfly-spline-3")
            butterflyMesh.active = true
            butterflyMesh.node.position = butterflySpline.getPointLinearMotion(t)
            butterflyMesh.node.needUpdate = true
            butterflyMesh.node.getMatrix()
            butterflyMesh.node.lookAt(butterflySpline.getPointLinearMotion(t + 0.01)) 
        } else {
            butterflyMesh.active = false
        }

    }

    stage1Prerender(){
        
    }
    
    stage2Prerender(){
        
        let rocksBack = this.scene.getNode("Back-Rocks").children
        for (let i = 0; i < rocksBack.length; i++) {
            const n = rocksBack[i];
            n.position[0] = n.initialPosition[0] + Math.cos(this.scene.time * n.seeds[0]) * 10
            n.position[1] = n.initialPosition[1] + Math.sin(this.scene.time * n.seeds[1]) * 5
            n.position[2] = n.initialPosition[2] + Math.sin(this.scene.time * n.seeds[0]) * 5
            n.rotation[2] = Math.cos(this.scene.time * n.seeds[2]) * 0.15
            n.needUpdate = true
        }

        let rockFront = this.scene.getNode("Front-Rocks").children
        for (let i = 0; i < rockFront.length; i++) {
            const n = rockFront[i];
            n.position[0] = n.initialPosition[0] + Math.cos(this.scene.time * n.seeds[0]) * 10
            n.position[1] = n.initialPosition[1] + Math.sin(this.scene.time * n.seeds[1]) * 5
            n.position[2] = n.initialPosition[2] + Math.sin(this.scene.time * n.seeds[0]) * 5
            n.rotation[2] = Math.cos(this.scene.time * n.seeds[2]) * 0.15
            n.needUpdate = true
        }

    }

    stage3Prerender(){

    }

}

export default AnimationManager